import { rupiah, tanggalID } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Flame, Pencil, Trash2 } from "lucide-react";
import { rit } from "@/components/app/bakar/StokKayuBar";

const sisaLabel = (n) => {
  if (n === null || n === undefined) return "";
  if (n > 0) return `${n} hari lagi`;
  if (n === 0) return "Siap dibongkar hari ini";
  return `Lewat ${Math.abs(n)} hari — siap dibongkar`;
};

export const BatchAktifCard = ({ b, onBongkar, onEdit, onDelete }) => {
  const durasi = Number(b.durasi_hari || 10);
  const jalan = Math.min(durasi, Math.max(0, durasi - Number(b.sisa_hari ?? durasi)));
  const pct = Math.round((jalan / durasi) * 100);
  const siap = (b.sisa_hari ?? 1) <= 0;
  return (
    <div className="card-flat p-4 space-y-3" data-testid={`batch-aktif-${b.id}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-900"><Flame size={15} className="text-orange-600"/>{b.produk_nama}</div>
          <div className="text-[11px] text-slate-500 mt-0.5">Mulai {tanggalID(b.tanggal_mulai)} · Bongkar ±{tanggalID(b.estimasi_bongkar)}</div>
        </div>
        <div className="flex gap-1">
          <button onClick={() => onEdit(b)} className="p-1.5 rounded-sm hover:bg-slate-100" data-testid={`edit-batch-${b.id}`}><Pencil size={14}/></button>
          <button onClick={() => onDelete(b)} className="p-1.5 rounded-sm hover:bg-rose-50" data-testid={`del-batch-${b.id}`}><Trash2 size={14} className="text-rose-600"/></button>
        </div>
      </div>
      <div>
        <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
          <div className={`h-full transition-[width] duration-700 ${siap ? "bg-emerald-500" : "bg-orange-500"}`} style={{ width: `${pct}%` }}/>
        </div>
        <div className={`text-xs mt-1 font-medium ${siap ? "text-emerald-700" : "text-orange-700"}`} data-testid={`batch-sisa-${b.id}`}>{sisaLabel(b.sisa_hari)}</div>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div><div className="text-slate-500">Kayu</div><div className="font-mono font-semibold">{rit(b.jumlah_rit)}</div></div>
        <div><div className="text-slate-500">Biaya Kayu</div><div className="font-mono font-semibold">{rupiah(b.biaya_kayu)}</div></div>
      </div>
      <Button onClick={() => onBongkar(b)} className={`w-full rounded-sm ${siap ? "brand-btn" : ""}`} variant={siap ? "default" : "outline"} data-testid={`bongkar-btn-${b.id}`}>Bongkar & Catat Hasil</Button>
    </div>
  );
};
